import { FormObjType } from "DataTypes/Form";

export const AddEditForm: FormObjType[] = [
  {
    id: "date-vital-sign-date",
    label: "Vital Sign Date",
    placeholder: "Select Vital Sign Date",
    boxType: "date-time",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-vital-name",
    label: "Vital Name",
    placeholder: "Enter Vital Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-vital-value",
    label: "Vital Value",
    placeholder: "Enter Vital Value",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-vital-unit",
    label: "Vital Unit",
    placeholder: "Enter Vital Unit",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
]